import {
  getDefaultTextModel,
  type TextModelSelectionId,
} from '@creanizer/types'

const currentModels = new Map<string, TextModelSelectionId>()

export function getCurrentGeneratorModel(tool: string): TextModelSelectionId {
  return currentModels.get(tool) ?? getDefaultTextModel(tool)
}

export function setCurrentGeneratorModel(
  tool: string,
  modelId: TextModelSelectionId
): void {
  currentModels.set(tool, modelId)
}

export function withGeneratorModel<T extends Record<string, unknown>>(
  params: T,
  modelId: TextModelSelectionId
): T & { modelId: TextModelSelectionId } {
  return {
    ...params,
    modelId,
  }
}
